import { useNavigate } from 'react-router-dom';
import './App.css';
import V2HomeCard from './V2HomeCard';
import V2HomeCardItem from './V2HomeCardItem';
import { Button } from 'primereact/button';
import UserHeader from './UserHeader';

function V2HomeCardAccount() {
    const navigate = useNavigate();

    return (
        <div>
            <V2HomeCard
                icon='pi pi-user'
                title='Accounts'
            >

                <V2HomeCardItem
                    title='My profile'
                    onClick={() => navigate('/myaccount')}
                />
                <div style={{ marginLeft: '-0.5em' }}>
                    <UserHeader user_id='me' />
                </div>
                <V2HomeCardItem
                    title='Setup more users'
                    deactivated={true}
                />
                <Button
                    severity='secondary'
                    label='Upgrate account'
                    size='small'
                    outlined
                    onClick={
                        () => navigate('/myaccount/')
                    }
                    icon='pi pi-send'
                    iconPos='right'
                    style={{ marginTop: '1em' }}
                />
            </V2HomeCard>
        </div>
    );
}

export default V2HomeCardAccount;